import { call, put, all, takeEvery } from 'redux-saga/effects'
import { openModal } from 'reducers/messageReducer';
import {
  historyInit,
  setInitDisplayInfo,
  historyFind,
  setUploadHistoryInfoResult,
  selectUploadCount,
  setUploadHistoryInfo
} from 'reducers/selectionFileUploadHistoryReducer';
import {
  initApi,
  findApi,
  selectUploadCountApi
} from 'apis/MCBPS040Api';
import { routeList } from 'routes/routes';
import history from 'utils/history';
import { magiContants } from 'utils/contants';

function* historyInitSaga(action: ReturnType<typeof historyInit>) {
  try {
    const data = yield call(initApi);
    yield put(setInitDisplayInfo(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* historyFindSaga(action: ReturnType<typeof historyFind>) {
  try {
    yield put(setUploadHistoryInfo())
    const data = yield call(findApi, action.payload)
    yield put(setUploadHistoryInfoResult(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* selectUploadCountSaga(action: ReturnType<typeof selectUploadCount>) {
  try {
    const data = yield call(selectUploadCountApi, action.payload)
    const param = {
      request: {
        ...data,
        screenId: magiContants.MCBPS040_SCREENID
      },
    }
    const path = {
      // 「応募者一覧」画面に遷移する
      pathname: routeList.applicantList,
      state: param,
    }
    history.push(path)
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* selectionFileUploadHistorySaga() {
  yield all([
    takeEvery(historyInit, historyInitSaga),
    takeEvery(historyFind, historyFindSaga),
    takeEvery(selectUploadCount, selectUploadCountSaga),
  ])
}